export class IsSubmissionSubmitAllowedRequestModel {  
    public submissionId: string;
    public lastModifiedTimestampTicks : string | undefined;
}